import { render, staticRenderFns } from "./detalleProductos.vue?vue&type=template&id=63cdbfda&scoped=true&"
import script from "./detalleProductos.vue?vue&type=script&lang=js&"
export * from "./detalleProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cdbfda",
  null
  
)

export default component.exports